import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'
import { useToast } from '@/hooks/use-toast'
import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase/client'

export function Navbar() {
  const { user, signOut } = useAuth()
  const { toast } = useToast()
  const [isAdmin, setIsAdmin] = useState(false)

  const handleSignOut = async () => {
    try {
      await signOut()
    } catch (error: any) {
      toast({
        variant: "destructive",
        title: "Erro ao sair",
        description: "Ocorreu um erro ao tentar fazer logout. Por favor, tente novamente."
      })
    }
  }

  useEffect(() => {
    let cancelled = false

    async function checkAdmin() {
      if (!user) {
        setIsAdmin(false)
        return
      }
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('metadata')
          .eq('id', user.id)
          .single()
        if (error) throw error
        if (!cancelled) setIsAdmin(!!data?.metadata?.is_admin)
      } catch {
        if (!cancelled) setIsAdmin(false)
      }
    }

    checkAdmin()
    return () => {
      cancelled = true
    }
  }, [user])

  return (
    <nav className="border-b border-foreground bg-foreground">
      <div className="w-full flex h-14 sm:h-16 items-center  px-4">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center">
          <img src="/logo-auth.png" alt="Serur Auth" className="h-6 sm:h-7 w-auto" />
        </Link>
        
        <div className="ml-auto flex items-center space-x-2 sm:space-x-4">
          {user && isAdmin ? (
            <Link to="/audit-logs">
              <Button
                variant="outline"
                className="border-muted-foreground bg-transparent text-background hover:bg-primary hover:text-primary-foreground hover:border-primary text-sm sm:text-base px-2 sm:px-4"
              >
                Logs
              </Button>
            </Link>
          ) : null}
          {user ? (
            <Button 
              variant="outline" 
              onClick={handleSignOut}
              className="border-muted-foreground bg-transparent text-background hover:bg-primary hover:text-primary-foreground hover:border-primary text-sm sm:text-base px-2 sm:px-4"
            >
              Sair
            </Button>
          ) : null}
        </div>
      </div>
    </nav>
  )
}